import {MoreDetailsTextSiBox} from "./more-details-text.si.box";

export const MoreDetailsTextSiCisBox = MoreDetailsTextSiBox